<template>

    <m-edit1/>

    <m-single-product-conditional-1 v-bind='{...{"conditions":[{"sourceType":"category","sourceItem":"1","selectedComponent":"mSingleProduct306","showWhatsAppButtonsMessage":null,"productCardName":"mProductCard315","relatedProducts":true},{"sourceType":null,"sourceItem":null,"selectedComponent":"mSingleProduct201","showWhatsAppButtonsMessage":null,"productCardName":"mProductCard315","relatedProducts":true}]},...{}}' :style='""' class="container my-3" ></m-single-product-conditional-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProductConditional1 from '@moeinmdn/miw-alpha-components/src/package/ConditionalComponent/SingleProductConditional1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProductConditional1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
